import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    SELLER_SEND_MOBILE_OTP,
    SELLER_VERIFY_MOBILE_OTP,
    SELLER_SEND_EMAIL_OTP,
    SELLER_VERIFY_EMAIL_OTP,
    SELLER_PERSONAL_INFORMATION_VALIDATE,
} from "../../../../config/api";
import { MuiOtpInput } from "mui-one-time-password-input";
const MuiOtpInputCast = MuiOtpInput as any;
import {
    Box,
} from "@mui/material";
import { Button, Input, H4, Contact, InternationalContact } from '@tviklax/ui-components';
import { useForm, Controller } from "react-hook-form";
import FullPageLoader from "../../../../components/common/FullPageLoader";
import VerifiedIcon from "@mui/icons-material/Verified";
import isPhoneValid from "../../../../utils/PhoneUtils";
import { toast } from "react-toastify";
import { SellerRegistrationFormData } from "../../components";
import { IoEyeOutline, IoEyeOffOutline, IoCloseCircleOutline, IoCheckmarkCircleOutline } from 'react-icons/io5';

interface PartnerInformationFormProps {
    formData: SellerRegistrationFormData;
    setFormData: React.Dispatch<React.SetStateAction<SellerRegistrationFormData>>;
    handleChange: (e: any) => void;
    handleNext: () => void;
    availableCountries: string[];
    country: string;
    formId: string;
    setNextDisabled?: (disabled: boolean) => void;
    setNextLabel?: (label?: string) => void;
}

const PartnerInformationForm: React.FC<PartnerInformationFormProps> = ({
    formData,
    setFormData,
    handleChange,
    handleNext,
    // availableCountries,
    country,
    formId,
    setNextDisabled,
    setNextLabel,
}) => {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const passwordRequirements = [
        { label: "Must be at least 8 characters long (letters & numbers)", test: (p: string) => p.length >= 8 },
        { label: "Must contain at least one lowercase character (a-z)", test: (p: string) => /[a-z]/.test(p) },
        { label: "Must contain at least one uppercase character (A-Z)", test: (p: string) => /[A-Z]/.test(p) },
        { label: "Must contain at least one numeric character (0-9)", test: (p: string) => /[0-9]/.test(p) },
        { label: "Must contain at least one allowed special character (@#$%!^&*_-)", test: (p: string) => /[@#$%!^&*_-]/.test(p) },
    ];

    const {
        control,
        register,
        trigger,
        handleSubmit,
        setValue,
        formState: { errors },
        clearErrors,
        setError,
    } = useForm({
        mode: "all",
        defaultValues: formData,
    });

    const [fullPageLoading, setFullPageLoading] = useState(false);
    const [emailOtpTimer, setEmailOtpTimer] = useState(0);
    const [isEmailOtpResendEnabled, setIsEmailOtpResendEnabled] = useState(false);
    const [emailOtpSending, setEmailOtpSending] = useState(false);
    const [emailOtp, setEmailOtp] = useState("");
    const [emailOtpBtnDisabled, setEmailOtpBtnDisabled] = useState(false);
    const [emailSendOtpBtnEnabled, setEmailSendOtpBtnEnabled] = useState(false);
    const [emailOtpSent, setEmailOtpSent] = useState(false);
    const [emailVerifyOtpBtnDisabled, setEmailVerifyOtpBtnDisabled] = useState(false);
    const [emailVerified, setEmailVerified] = useState(
        formData?.emailVerified || false
    );
    const [emailVerifiedValue, setEmailVerifiedValue] = useState(
        formData?.emailVerified ? formData?.email : ""
    );

    const validateEmail = (e: any) => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        if (emailRegex.test(e.target.value)) {
            setEmailSendOtpBtnEnabled(true);
            checkIfEmailVerified(e.target.value);
        } else {
            setEmailSendOtpBtnEnabled(false);
            setEmailVerified(false);
            setEmailOtpSent(false);
            setFormData((prev) => ({ ...prev, emailVerified: false }));
        }
    };

    const checkIfEmailVerified = (emailVal: string) => {
        if (emailVerifiedValue === emailVal) {
            setEmailVerified(true);
            setEmailOtpSent(false);
            setEmailSendOtpBtnEnabled(false);
            setFormData((prev) => ({ ...prev, emailVerified: true }));
        } else {
            setEmailVerified(false);
            setEmailOtpSent(false);
            setEmailSendOtpBtnEnabled(true);
            setFormData((prev) => ({ ...prev, emailVerified: false }));
        }
    };

    const [mobileOtpTimer, setMobileOtpTimer] = useState(0);
    const [isMobileOtpResendEnabled, setIsMobileOtpResendEnabled] = useState(false);
    const [mobileOtpSending, setMobileOtpSending] = useState(false);
    const [mobileOtp, setMobileOtp] = useState("");
    const [mobileOtpBtnDisabled, setMobileOtpBtnDisabled] = useState(false);
    const [mobileSendOtpBtnEnabled, setMobileSendOtpBtnEnabled] = useState(false);
    const [mobileOtpSent, setMobileOtpSent] = useState(false);
    const [mobilVerifyOtpBtnDisabled, setMobilVerifyOtpBtnDisabled] = useState(false);
    const [mobileVerified, setMobileVerified] = useState(
        formData?.mobileVerified || false
    );
    const [mobileVerifiedValue, setMobileVerifiedValue] = useState(
        formData?.mobileVerified ? formData?.mobileNumber : ""
    );

    const validateMobileNumber = (e: any) => {
        if (isPhoneValid(e.target.value)) {
            setMobileSendOtpBtnEnabled(true);
            checkIfMobileVerified(e.target.value);
        } else {
            setMobileSendOtpBtnEnabled(false);
            setMobileVerified(false);
            setMobileOtpSent(false);
            setFormData((prev) => ({ ...prev, mobileVerified: false }));
        }
    };

    const checkIfMobileVerified = (mobileVal: string) => {
        mobileVal = mobileVal.replace(/\s/g, "");
        if (mobileVerifiedValue === mobileVal) {
            setMobileVerified(true);
            setMobileOtpSent(false);
            setMobileSendOtpBtnEnabled(false);
            setFormData((prev) => ({ ...prev, mobileVerified: true }));
        } else {
            setMobileVerified(false);
            setMobileOtpSent(false);
            setMobileSendOtpBtnEnabled(true);
            setFormData((prev) => ({ ...prev, mobileVerified: false }));
        }
    };

    useEffect(() => {
        let emailOtpInterval: NodeJS.Timeout;
        let mobileOtpInterval: NodeJS.Timeout;

        if (emailOtpTimer > 0) {
            emailOtpInterval = setInterval(() => {
                setEmailOtpTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(emailOtpInterval);
                        setIsEmailOtpResendEnabled(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        if (mobileOtpTimer > 0) {
            mobileOtpInterval = setInterval(() => {
                setMobileOtpTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(mobileOtpInterval);
                        setIsMobileOtpResendEnabled(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => {
            clearInterval(emailOtpInterval);
            clearInterval(mobileOtpInterval);
        };
    }, [emailOtpTimer, mobileOtpTimer]);

    const [btnDisabled, setBtnDisabled] = useState(false);

    useEffect(() => {
        setNextDisabled?.(btnDisabled);
        setNextLabel?.(btnDisabled ? "Processing..." : undefined);
    }, [btnDisabled, setNextDisabled, setNextLabel]);

    const sendEmailOtp = () => {
        clearErrors("email");
        // clearErrors("email_otp_code");
        trigger("email");
        setEmailOtp("");
        if (errors.email) {
            console.log(errors.email);
            return false;
        }
        setEmailOtpSending(true);
        setEmailOtpBtnDisabled(true);
        axios
            .post(SELLER_SEND_EMAIL_OTP, formData)
            .then((response) => {
                if (response?.data?.success && response?.data?.code === 200) {
                    const isDataExists = response?.data?.data?.is_data_exists;
                    if (isDataExists === 1) {
                        toast.success(response?.data?.message);
                        const sellerData = response?.data?.data?.seller_info;
                        setFormData((prev) => ({ ...prev, ...sellerData }));

                        setEmailVerified(sellerData.emailVerified);
                        setEmailVerifiedValue(sellerData.email);
                        setEmailSendOtpBtnEnabled(false);
                        setEmailOtpSent(true);

                        if (sellerData.mobileVerified) {
                            setMobileVerified(sellerData.mobileVerified);
                            setMobileVerifiedValue(sellerData.mobileNumber);
                            setMobileSendOtpBtnEnabled(false);
                            setMobileOtpSent(true);
                        }

                        Object.entries(sellerData).forEach(([field, value]) => {
                            setValue(field as any, value);
                            clearErrors(field as any);
                        });
                    } else {
                        toast.success(response?.data?.message);
                        setEmailOtpSent(true);
                        setEmailSendOtpBtnEnabled(false);
                        setIsEmailOtpResendEnabled(false);
                        setEmailOtpTimer(60);
                    }
                } else {
                    toast.error(response?.data?.message);
                }
            })
            .catch((error) => {
                if (
                    !error?.response?.data?.success &&
                    error?.response?.status === 422
                ) {
                    const validation_errors = error?.response?.data?.message;
                    Object.entries(validation_errors).forEach(([field, messages]: [string, any]) => {
                        setError(field as any, {
                            type: "manual",
                            message: messages[0],
                        });
                    });
                } else {
                    toast.error(error?.response?.data?.message);
                }
            })
            .finally(() => {
                setEmailOtpSending(false);
                setEmailOtpBtnDisabled(false);
            });
    };

    const verifyEmailOtp = () => {
        setEmailVerifyOtpBtnDisabled(true);
        axios
            .post(SELLER_VERIFY_EMAIL_OTP, {
                email_otp_code: emailOtp,
                email: formData?.email,
            })
            .then((response) => {
                if (response?.data?.success && response?.data?.code === 200) {
                    setEmailVerified(true);
                    setEmailVerifiedValue(response?.data?.data?.email);
                    clearErrors("email");
                    setFormData((prev) => ({ ...prev, emailVerified: true }));
                } else {
                    setError("email" as any, { // Using 'email' instead of 'email_otp_code' if not registered
                        type: "manual",
                        message: response?.data?.message
                    });
                    // Or register email_otp_code manually if needed
                }
            })
            .catch((error) => {
                if (
                    !error?.response?.data?.success &&
                    error?.response?.status === 422
                ) {
                    const validation_errors = error?.response?.data?.message;
                    Object.entries(validation_errors).forEach(([field, messages]: [string, any]) => {
                        setError(field as any, {
                            type: "manual",
                            message: messages[0],
                        });
                    });
                } else {
                    toast.error(error?.response?.data?.message);
                }
            })
            .finally(() => {
                setEmailVerifyOtpBtnDisabled(false);
            });
    };

    const sendMobileOtp = () => {
        clearErrors("mobileNumber");
        // clearErrors("mobile_otp_code");
        trigger("mobileNumber" as any);
        setMobileOtp("");
        if (errors.mobileNumber) {
            return false;
        }
        setMobileOtpSending(true);
        setMobileOtpBtnDisabled(true);
        axios
            .post(SELLER_SEND_MOBILE_OTP, formData)
            .then((response) => {
                if (response?.data?.success && response?.data?.code === 200) {
                    const isDataExists = response?.data?.data?.is_data_exists;
                    if (isDataExists === 1) {
                        toast.success(response?.data?.message);
                        const sellerData = response?.data?.data?.seller_info;
                        setFormData((prev) => ({ ...prev, ...sellerData }));
                        setMobileVerified(sellerData.mobileVerified);
                        setMobileVerifiedValue(sellerData.mobileNumber);
                        setEmailVerified(sellerData.emailVerified);
                        setEmailVerifiedValue(sellerData.email);
                        setMobileSendOtpBtnEnabled(false);
                        setMobileOtpSent(true);
                        setEmailSendOtpBtnEnabled(false);
                        setEmailOtpSent(true);
                        Object.entries(sellerData).forEach(([field, value]) => {
                            setValue(field as any, value);
                            clearErrors(field as any);
                        });
                    } else {
                        toast.success(response?.data?.message);
                        setMobileOtpSent(true);
                        setMobileSendOtpBtnEnabled(false);
                        setIsMobileOtpResendEnabled(false);
                        setMobileOtpTimer(60);
                    }
                }
            })
            .catch((error) => {
                if (
                    !error?.response?.data?.success &&
                    error?.response?.status === 422
                ) {
                    const validation_errors = error?.response?.data?.message;
                    Object.entries(validation_errors).forEach(([field, messages]: [string, any]) => {
                        setError(field as any, {
                            type: "manual",
                            message: messages[0],
                        });
                    });
                } else {
                    toast.error(error?.response?.data?.message);
                }
            })
            .finally(() => {
                setMobileOtpSending(false);
                setMobileOtpBtnDisabled(false);
            });
    };

    const verifyMobileOtp = () => {
        setMobilVerifyOtpBtnDisabled(true);
        axios
            .post(SELLER_VERIFY_MOBILE_OTP, {
                mobile_otp_code: mobileOtp,
                mobileNumber: formData?.mobileNumber,
            })
            .then((response) => {
                if (response?.data?.success && response?.data?.code === 200) {
                    setMobileVerified(true);
                    setMobileVerifiedValue(response?.data?.data?.mobileNumber);
                    clearErrors("mobileNumber" as any);
                    setFormData((prev) => ({ ...prev, mobileVerified: true }));
                } else {
                    // Handle error
                }
            })
            .catch((error) => {
                if (
                    !error?.response?.data?.success &&
                    error?.response?.status === 422
                ) {
                    const validation_errors = error?.response?.data?.message;
                    Object.entries(validation_errors).forEach(([field, messages]: [string, any]) => {
                        setError(field as any, {
                            type: "manual",
                            message: messages[0],
                        });
                    });
                } else {
                    toast.error(error?.response?.data?.message);
                }
            })
            .finally(() => {
                setMobilVerifyOtpBtnDisabled(false);
            });
    };

    const onSubmit = () => {
        if (btnDisabled) return;
        if (!mobileVerified || !emailVerified) {
            if (!mobileVerified) {
                if (mobileOtpSent) {
                    // setError("mobile_otp_code", {
                    //   type: "manual",
                    //   message: "Please verify OTP",
                    // });
                    toast.error("Please verify mobile OTP");
                } else {
                    setMobileSendOtpBtnEnabled(true);
                    setError("mobileNumber" as any, {
                        type: "manual",
                        message: "Please verify your mobile number through OTP",
                    });
                }
            }
            if (!emailVerified) {
                if (emailOtpSent) {
                    // setError("email_otp_code", {
                    //   type: "manual",
                    //   message: "Please verify OTP",
                    // });
                    toast.error("Please verify email OTP");
                } else {
                    setEmailSendOtpBtnEnabled(true);
                    setError("email", {
                        type: "manual",
                        message: "Please verify your email address through OTP",
                    });
                }
            }
            return false;
        }
        setFullPageLoading(true);
        setBtnDisabled(true);
        axios
            .post(SELLER_PERSONAL_INFORMATION_VALIDATE, formData)
            .then((response) => {
                if (response?.data?.success && response?.data?.code === 200) {
                    handleNext();
                }
            })
            .catch((error) => {
                if (
                    !error?.response?.data?.success &&
                    error?.response?.status === 422
                ) {
                    const validation_errors = error?.response?.data?.message;
                    Object.entries(validation_errors).forEach(([field, messages]: [string, any]) => {
                        setError(field as any, {
                            type: "manual",
                            message: messages[0],
                        });
                    });
                } else {
                    toast.error(error?.response?.data?.message);
                }
            })
            .finally(() => {
                setBtnDisabled(false);
                setFullPageLoading(false);
            });
    };

    return (
        <form id={formId} onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <FullPageLoader loading={fullPageLoading} color="#f86400" />

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ pb: 1, pt: 1 }}>
                    <H4 style={{ fontWeight: 600 }}>Personal Information</H4>
                </Box>

                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3, mt: 5 }}>
                    <Box>
                        <Input
                            placeholder="First Name"
                            {...register("firstname", {
                                required: "First name is required",
                                minLength: {
                                    value: 2,
                                    message: "First name must be at least 2 characters",
                                },
                            })}
                            value={formData.firstname}
                            onChange={handleChange}
                            error={errors.firstname?.message as string}
                            style={{ marginBottom: '1rem' }}
                        />
                    </Box>
                    <Box>
                        <Input
                            placeholder="Last Name"
                            {...register("lastname", {
                                required: "Last name is required",
                            })}
                            value={formData.lastname}
                            onChange={handleChange}
                            error={errors.lastname?.message as string}
                            style={{ marginBottom: '1rem' }}
                        />
                    </Box>

                    <Box>
                        <Controller
                            name="mobileNumber"
                            control={control}
                            defaultValue=""
                            rules={{
                                required: "Mobile number is required",
                                validate: {
                                    isValidPhone: (value) =>
                                        isPhoneValid(value) || "Please enter a valid phone number",
                                },
                            }}
                            render={({ field: { onChange, value, name } }) => (
                                <InternationalContact
                                    variant="cell"
                                    value={value}
                                    name={name}
                                    label="Mobile Number"
                                    onChange={(phone: string) => {
                                        onChange(phone);
                                        handleChange({ target: { value: phone } });
                                        validateMobileNumber({ target: { value: phone } });
                                    }}
                                    defaultCountry={country}
                                    otpConfig={{
                                        enabled: mobileSendOtpBtnEnabled,
                                        disabled: mobileOtpBtnDisabled,
                                        onSend: sendMobileOtp,
                                        isVerified: mobileVerified,
                                    }}
                                    error={errors.mobileNumber?.message as string}
                                    helperText={errors.mobileNumber?.message as string}
                                    style={{ marginBottom: '1rem' }}
                                />
                            )}
                        />

                        {mobileOtpSent && !mobileVerified && (
                            <Box sx={{ mt: 2 }}>
                                <Box sx={{ fontSize: '14px', mb: 1 }}>
                                    Enter the OTP sent to your mobile number
                                </Box>
                                <Controller
                                    name={"mobile_otp_code" as any}
                                    control={control}
                                    rules={{
                                        required: "OTP is required",
                                        validate: (value) =>
                                            value?.length === 6 || "Please enter 6 digit OTP",
                                    }}
                                    render={({ field, fieldState }) => (
                                        <Box>
                                            <MuiOtpInputCast
                                                sx={{
                                                    gap: 1,
                                                    "& .MuiInputBase-root": {
                                                        width: "40px",
                                                        height: "40px",
                                                    },
                                                }}
                                                {...field}
                                                autoFocus
                                                length={6}
                                                value={mobileOtp}
                                                onChange={(value: string) => {
                                                    setMobileOtp(value);
                                                    field.onChange(value);
                                                }}
                                            />
                                            {fieldState.invalid ? (
                                                <Box sx={{ color: 'error.main', fontSize: '0.75rem', mt: 1 }}>
                                                    {fieldState.error?.message}
                                                </Box>
                                            ) : null}
                                        </Box>
                                    )}
                                />

                                <Button
                                    size="sm"
                                    variant="ghost"
                                    onClick={verifyMobileOtp}
                                    disabled={mobilVerifyOtpBtnDisabled}
                                >
                                    Verify OTP
                                </Button>
                                <Box sx={{ fontSize: '14px', mt: 1 }}>
                                    Didn't receive OTP?
                                    {mobileOtpSending ? (
                                        <span style={{ marginLeft: '20px' }}>Loading...</span>
                                    ) : (
                                        <Button
                                            variant="ghost"
                                            onClick={sendMobileOtp}
                                            disabled={!isMobileOtpResendEnabled}
                                        >
                                            {isMobileOtpResendEnabled ? (
                                                <span style={{ textDecoration: 'underline' }}>Resend OTP</span>
                                            ) : (
                                                <span>Resend OTP in {mobileOtpTimer}s</span>
                                            )}
                                        </Button>
                                    )}
                                </Box>
                            </Box>
                        )}
                    </Box>

                    <Box>
                        <Contact
                            variant="email"
                            label=""
                            placeholder="Email"
                            {...register("email", {
                                required: "Email is required",
                                pattern: {
                                    value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                    message: "Please enter a valid email address",
                                },
                            })}
                            value={formData?.email}
                            onChange={(e) => {
                                handleChange(e);
                                validateEmail(e);
                            }}
                            error={errors.email?.message as string}
                            style={{ marginBottom: '1rem' }}
                            endAdornment={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {emailSendOtpBtnEnabled && !emailVerified && (
                                        <Box
                                            onClick={!emailOtpBtnDisabled ? sendEmailOtp : undefined}
                                            sx={{
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                padding: "4px 8px",
                                                backgroundColor: emailOtpBtnDisabled ? "#ccc" : "#f86400",
                                                color: "#fff",
                                                borderRadius: "4px",
                                                cursor: emailOtpBtnDisabled ? "not-allowed" : "pointer",
                                                whiteSpace: "nowrap"
                                            }}
                                        >
                                            {emailOtpBtnDisabled ? "Sending..." : "Send Otp"}
                                        </Box>
                                    )}
                                    {emailVerified && <VerifiedIcon sx={{ color: "#22C55E" }} />}
                                </Box>
                            }
                        />
                    </Box>

                    {emailOtpSent && !emailVerified && (
                        <Box sx={{ mt: 2 }}>
                            <Box sx={{ fontSize: '14px', mb: 1 }}>
                                Enter the OTP sent to your email address
                            </Box>
                            <Controller
                                name={"email_otp_code" as any}
                                control={control}
                                rules={{
                                    required: "OTP is required",
                                    validate: (value) =>
                                        value?.length === 6 || "Please enter 6 digit OTP",
                                }}
                                render={({ field, fieldState }) => (
                                    <Box>
                                        <MuiOtpInputCast
                                            sx={{
                                                gap: 1,
                                                "& .MuiInputBase-root": {
                                                    width: "40px",
                                                    height: "40px",
                                                },
                                            }}
                                            {...field}
                                            autoFocus
                                            length={6}
                                            value={emailOtp}
                                            onChange={(value: string) => {
                                                setEmailOtp(value);
                                                field.onChange(value);
                                            }}
                                        />
                                        {fieldState.invalid ? (
                                            <Box sx={{ color: 'error.main', fontSize: '0.75rem', mt: 1 }}>
                                                {fieldState.error?.message}
                                            </Box>
                                        ) : null}
                                    </Box>
                                )}
                            />

                            <Button
                                size="sm"
                                variant="ghost"
                                onClick={verifyEmailOtp}
                                disabled={emailVerifyOtpBtnDisabled}
                            >
                                Verify OTP
                            </Button>
                            <Box sx={{ fontSize: '14px', mt: 1 }}>
                                Didn't receive OTP?
                                {emailOtpSending ? (
                                    <span style={{ marginLeft: '20px' }}>Loading...</span>
                                ) : (
                                    <Button
                                        variant="ghost"
                                        onClick={sendEmailOtp}
                                        disabled={!isEmailOtpResendEnabled}
                                    >
                                        {isEmailOtpResendEnabled ? (
                                            <span style={{ textDecoration: 'underline' }}>Resend OTP</span>
                                        ) : (
                                            <span>Resend OTP in {emailOtpTimer}s</span>
                                        )}
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    )}
                </Box>

                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
                    <Box>
                        <Input
                            placeholder="Password"
                            type={showPassword ? "text" : "password"}
                            {...register("password", {
                                required: "Password is required",
                                minLength: {
                                    value: 8,
                                    message: "Password must be at least 8 characters",
                                },
                            })}
                            value={formData.password}
                            onChange={handleChange}
                            error={errors.password?.message as string}
                            style={{ marginBottom: '1rem' }}
                            endAdornment={
                                <Box
                                    onClick={() => setShowPassword(!showPassword)}
                                    sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', color: '#f86400' }}
                                >
                                    {showPassword ? <IoEyeOffOutline size={20} /> : <IoEyeOutline size={20} />}
                                </Box>
                            }
                        />
                    </Box>
                    <Box>
                        <Input
                            placeholder="Confirm Password"
                            type={showConfirmPassword ? "text" : "password"}
                            {...register("confirmPassword", {
                                required: "Confirm password is required",
                                validate: (value) =>
                                    value === formData.password || "Passwords do not match",
                            })}
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            error={errors.confirmPassword?.message as string}
                            style={{ marginBottom: '1rem' }}
                            endAdornment={
                                <Box
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', color: '#f86400' }}
                                >
                                    {showConfirmPassword ? <IoEyeOffOutline size={20} /> : <IoEyeOutline size={20} />}
                                </Box>
                            }
                        />
                    </Box>
                </Box>

                <Box sx={{ mt: 1, mb: 2 }}>
                    <Box sx={{ fontSize: '14px', fontWeight: 600, mb: 1, color: '#251e1e' }}>
                        Password must meet the following requirements:
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        {passwordRequirements.map((req, index) => {
                            const isMet = req.test(formData.password || '');
                            return (
                                <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1, color: isMet ? '#22C55E' : '#94a3b8', fontSize: '13px' }}>
                                    {isMet ? <IoCheckmarkCircleOutline size={18} /> : <IoCloseCircleOutline size={18} />}
                                    <span>{req.label}</span>
                                </Box>
                            );
                        })}
                    </Box>
                </Box>
            </Box>

        </form>
    );
};

export default PartnerInformationForm;
